import { useContext } from 'react';
import { CommentStoreContext } from './contextStore';

export function useCommentStoreContext() {
	const ctx = useContext(CommentStoreContext);
	if (ctx === null) {
		throw new Error(
			'useCommentStoreContext was called outside of CommentStore context'
		);
	}

	return ctx;
}
